import Preloader from './Preloader';
import './Preloader.scss';

export default Preloader;
